import publicReq, { privateReq, imageReq } from './axiosConfig';

export const addInsightService = (data) =>
    privateReq.post("/insight/add-insight", data);
export const getInsightListService = (data) =>
    privateReq.get("/insight/insight-list" + data);

export const updateInsightService = (data) => imageReq.post("/update-insight", data);

export const deleteInightService = (data) => privateReq.delete("/delete-insight/" + data.id);